<template>
    <div class="field">
        <transition name="fade">
            <label v-if="title" class="field-label" :title="title">
                {{ title }}
                <span class="required">{{ required ? '*' : '' }}</span>
                <tooltip v-if="hint" :text="hint"></tooltip>
            </label>
        </transition>
        <input
            ref="input"
            class="field-input"
            style="width: 100%;"
            type="text"
            :name="name"/>
    </div>
</template>

<script type="text/babel">
import _ from 'lodash';

import TooltipComponent from '../tooltip/tooltip.component';

export default {
    name: 'kendo-dropdown',

    props: {
        dataSource: Array,
        label: String,
        hint: String,
        name: String,
        description: String,
        placeholder: String,
        required: [Boolean, String],
        listWidth: {
            type: Number
        },
        index: {
            type: Number,
            default: 0
        },
        dataTextField: {
            type: String,
            default: 'text'
        },
        dataValueField: {
            type: String,
            default: 'value'
        },
        template: {
            type: String,
            default: ''
        },
        value: {
            type: [Object, Number, String]
        }
    },

    data () {
        const index = this.getIndex();

        const config = {
            dataTextField: this.dataTextField,
            dataValueField: this.dataValueField,
            dataSource: {
                data: this.dataSource
            },
            template: this.template,
            index,
            change: this.onChange,
            filter: _.size(this.dataSource) > 5 ? 'contains' : 'none'
        };

        if (this.placeholder) {
            config.optionLabel = this.placeholder;
        }

        return {
            title: this.label,
            config,
            widget: undefined
        };
    },

    mounted () {
        this.widget = new kendo.ui.DropDownList(this.$refs.input, this.config);

        if (this.listWidth) {
            this.widget.list.width(this.listWidth);
        }
    },

    destroyed () {
        this.widget.destroy();
    },

    methods: {
        getIndexValue (val) {
            if (_.isObject(val)) {
                const dataItems = this.widget ? this.widget.dataItems() : this.dataSource;
                const index = _.findIndex(dataItems, d => {
                    if (_.isArray(val.value)) {
                        return _.some(val.value, v => String(v).toLowerCase() === String(d[this.dataValueField]).toLowerCase());
                    }
                    return String(val.value).toLowerCase() === String(d[this.dataValueField]).toLowerCase();
                }) + (this.placeholder ? 1 : 0);
                return index > 0 ? index : 0;
            }
            return 0;
        },

        getIndex (value = this.value) {
            return (_.isObject(value) && value.value) ? this.getIndexValue(value) : (_.isString(value) || _.isNumber(value)) ? this.getIndexValue({ value }) : this.index;
        },

        onChange () {
            const data = this.formatData();
            this.$emit('input', data);
            this.$emit('change', data);
        },

        formatData () {
            return {
                metadata: {
                    name: this.name,
                    text: this.dataTextField,
                    value: this.dataValueField,
                    properties: Object.keys(this.dataSource[0] || {})
                },
                value: isNaN(Number(this.widget.value())) ? this.widget.value() : Number(this.widget.value()),
                text: this.widget.text()
            };
        }
    },

    watch: {
        value (newVal, oldVal) {
            if (!_.isEqual(newVal, oldVal)) {
                this.widget.select(this.getIndex(newVal));
            }
        },

        dataSource (val) {
            if (_.size(val) > 5) {
                this.widget.setOptions({ filter: 'contains' });
            } else {
                this.widget.setOptions({ filter: 'none' });
            }

            this.widget.setDataSource(new kendo.data.DataSource({ data: val }));

            // this.widget.value(this.getIndex());
        },

        label (val) {
            this.title = val;
        },

        dataTextField (val) {
            this.widget.setOptions({ dataTextField: val });
        },

        dataValueField (val) {
            this.widget.setOptions({ dataValueField: val });
        }
    },

    components: {
        tooltip: TooltipComponent
    }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    $helpColor: #ff3860;
    $labelColor: #888;

    .required {
        color: $helpColor;
    }

    // Animations
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }

    .fade-enter, .fade-leave-active {
        opacity: 0
    }
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/kendo-dropdown/kendo-dropdown.component.vue